import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetOrderNonFundingAttachments(orderId) {
  const response = await $.soap({
    body: {
      GetOrderNonFundingAttachments: {
        $xmlns: 'http://dla.mil/ems/bpm/attachment',
        OrderID: orderId
      }
    },
    blueprintArrays: ['GetOrderNonFundingAttachmentsResponse.Attachments.Attachment'],
    blueprint: {
      attachments: [
        '$..Attachment',
        {
          id: '$..ID',
          objectTypeId: '$..ObjectTypeID',
          objectId: '$..ObjectID',
          documentTypeId: '$..DocumentTypeID',
          fileName: '$..FileName',
          uploadedBy: '$..UploadedBy',
          uploadedOn: '$..UploadedOn'
        }
      ]
    }
  });

  cleanUpResponse(response);
  return response.attachments;
}
